import { getSecret } from "../lib/secretsManager";

const region = atob(process.env.REACT_APP_AWS_REGION || "");
const secretName = atob(process.env.REACT_APP_AWS_SECRET_MANAGER_NAME || "");
let cachedConfig: Record<string, any> | undefined;

export async function loadConfig() {
  if (!cachedConfig) {
    cachedConfig = await getSecret(region, secretName);

    if (!cachedConfig) {
      throw new Error("Failed to load configuration from Secrets Manager.");
    }
  }
  return cachedConfig;
}

// Export config as a Promise so it can be used without top-level await
export const configPromise = loadConfig();
